export default __webpack_public_path__ + "static/media/ARRENDAM2024.84587ddc.pdf";